import { Button, Drawer, Form, Space, Input, Popover, message } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BiExport, BiMailSend } from "react-icons/bi";
import { RiFilterOffLine, RiMailSendLine } from "react-icons/ri";
import { useSendEmailMutation } from "../../../store/endpoints/email/email";
import { timeLap } from "../../../utils/timeLap";
import { blobToDataUrl, ExportToExcel, getExportData } from "../../../utils/XLSXExport";
const { Search } = Input;

export default function VehiclePanel({
  setShowDetails,
  isVisible,
  vehicles,
  title,
}: any) 
{

  const [search, setSearch] = useState("");
  const [form] = Form.useForm();

  const [messageModal, toggleMessageModal] = useState(false)
  const [ sendEmail, emailResult ] = useSendEmailMutation()
  const [ emailForm ] = Form.useForm()

  const sendMail = async (values: any) => {
    const data = vehicles?.map((record: any, index: number) => {
      return {
        "S/N": index + 1,
        Customer: record?.vehicle?.contact?.customer?.name === null  ? "-" : record?.vehicle?.contact?.customer?.name,
        Registration: record?.vehicle?.registration === null ? "-" : record?.vehicle?.registration,
        Model: record?.vehicle?.model === null ? "-" : record?.vehicle?.model,
        "Time In": moment(record?.timein).format( "Do, MMM YYYY hh:mm A" ),
        "Time Out": record?.timeout !== null ? moment(record?.timeout).format( "Do, MMM YYYY hh:mm A" ) : null,
        "Time Taken": timeLap(record?.timein, record?.timeout),
      };
    })

    const raw  = getExportData(data)
    const uri = await blobToDataUrl(raw)
    
    sendEmail({
      email: values.email,
      subject: values.subject,
      data: uri
    })

    message.success("Email Sent Successfully")
    emailForm.resetFields()
    toggleMessageModal(false)
  }

  useEffect(() => {
    if (emailResult.isSuccess) {
      message.success("Email Sent Successfully");
    }
  }, [emailResult]);

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  return (
    <Drawer
      title={`${title}`}
      placement={"right"}
      width={800}
      onClose={() => setShowDetails(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space className="flex justify-center items-center">
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowDetails(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="font-toyota">
        <div className="flex justify-between items-center border-b border-gray-300 mb-2 pb-2 -mt-4">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search by registration"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
          </div>
          <div className="flex flex-row">
            <Popover
              content={
                <>
                  <Form
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    initialValues={{ remember: true }}
                    form={emailForm}
                    onFinish={sendMail}
                    // onFinishFailed={onFinishFailed}
                    autoComplete="off"
                  >
                    <Form.Item
                      label="Email"
                      name="email"
                      rules={[{ required: true, message: "Email is Required" }]}
                    >
                      <Input placeholder="Email" />
                    </Form.Item>
                    <Form.Item
                      label="Subject"
                      name="subject"
                      rules={[
                        { required: true, message: "Subject is Required" },
                      ]}
                    >
                      <Input placeholder="Email Subject" />
                    </Form.Item>
                    <div className="flex flex-row justify-between">
                      <Form.Item wrapperCol={{ offset: 12, span: 8 }}>
                        <Button type="primary" htmlType="submit">
                          Submit
                        </Button>
                      </Form.Item>

                      <Form.Item wrapperCol={{ offset: 0, span: 8 }}>
                        <Button
                          onClick={() => {
                            toggleMessageModal(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </>
              }
              title="Message Content"
              trigger="focus"
              placement="left"
              visible={messageModal}
              // onVisibleChange={}
            >
              <button className="flex ml-4 justify-center items-center border p-1 px-3 hover:bg-green-100">
                <RiMailSendLine size={24} />
                <span
                  className="ml-2"
                  onClick={async () => {
                    toggleMessageModal(true);
                    // const data = vehicles?.map((record: any, index: number) => {
                    //   return {
                    //     "S/N": index + 1,
                    //     Customer: record?.vehicle?.contact?.customer?.name === null  ? "-" : record?.vehicle?.contact?.customer?.name,
                    //     Registration: record?.vehicle?.registration === null ? "-" : record?.vehicle?.registration,
                    //     Model: record?.vehicle?.model === null ? "-" : record?.vehicle?.model,
                    //     "Time In": moment(record?.timein).format( "Do, MMM YYYY hh:mm A" ),
                    //     "Time Out": record?.timeout !== null ? moment(record?.timeout).format( "Do, MMM YYYY hh:mm A" ) : null,
                    //     "Time Taken": timeLap(record?.timein, record?.timeout),
                    //   };
                    // })

                    // const uri = getExportData(data)
                    // ExportToExcel(data, "Vehicles.xlsx")
                  }}
                >
                  Send Email
                </span>
              </button>
            </Popover>
            <button
              color="#E50000"
              className="flex ml-4 justify-center items-center border p-1 hover:bg-green-100"
            >
              <BiExport size={24} />
              <span
                className="ml-2"
                onClick={async () => {
                  const data = vehicles?.map((record: any, index: number) => {
                    return {
                      "S/N": index + 1,
                      Customer:
                        record?.vehicle?.contact?.customer?.name === null
                          ? "-"
                          : record?.vehicle?.contact?.customer?.name,
                      Registration:
                        record?.vehicle?.registration === null
                          ? "-"
                          : record?.vehicle?.registration,
                      Model:
                        record?.vehicle?.model === null
                          ? "-"
                          : record?.vehicle?.model,
                      "Time In": moment(record?.timein).format(
                        "Do, MMM YYYY hh:mm A"
                      ),
                      "Time Out":
                        record?.timeout !== null
                          ? moment(record?.timeout).format(
                              "Do, MMM YYYY hh:mm A"
                            )
                          : null,
                      "Time Taken": timeLap(record?.timein, record?.timeout),
                    };
                  });
                  ExportToExcel(data, "Vehicles.xlsx");
                }}
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>
        <div className="flex pt-1 pb-2 border-b border-gray-300">
          <div className="mr-2 w-10 text-center font-bold">S/N.</div>
          <div className="flex justify-between items-center flex-1">
            <div className="flex items-center">
              <div className="w-52 truncate font-bold">Customer</div>
              <div className="w-36 truncate text-left font-bold">
                Registration
              </div>
              <div className="w-36 truncate font-bold">Model</div>
            </div>
            <div className="font-bold w-full">Time Stayed</div>
          </div>
        </div>
        {vehicles
          ?.filter((vehicle: any) =>
            vehicle?.vehicle?.registration?.includes(search)
          )
          .map((item: any, index: number) => (
            <div className="flex py-1 border-b border-gray-300" key={index}>
              <div className="mr-2 w-10 text-center">{index + 1}.</div>
              <div className="flex justify-between items-center flex-1">
                <div className="flex items-center">
                  <div className="w-52 truncate">
                    {item?.vehicle?.contact?.customer?.name === null
                      ? "-"
                      : item?.vehicle?.contact?.customer?.name}
                  </div>
                  <div className="w-36 truncate">
                    {item?.vehicle?.registration === null
                      ? "-"
                      : item?.vehicle?.registration}
                  </div>
                  <div className="w-36 truncate">
                    {item?.vehicle?.model === null ? "-" : item?.vehicle?.model}
                  </div>
                </div>
                <div className="w-full">
                  {item.timeout === null ? (
                    <div className="flex">
                      <div className="text-left w-40">
                        {timeLap(item?.timein, new Date())}
                      </div>
                    </div>
                  ) : (
                    <div className="flex">
                      <div className="mr-2 text-left">
                        {timeLap(item?.timein, item?.timeout)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        <div className="flex justify-between items-start border-t-2 border-b-2 py-2">
          <div className="ml-2">Total Vehicles</div>
          <div className="font-bold">
            {
              vehicles?.filter((vehicle: any) =>
                vehicle?.vehicle?.registration?.includes(search)
              ).length
            }
          </div>
        </div>
      </div>
    </Drawer>
  );
}
